var desktopScreenWidth = 990;

function throttle(delay, callback) {
    var previousCall = new Date().getTime();
    return function() {
        var time = new Date().getTime();
        if ((time - previousCall) >= delay) {
            previousCall = time;
            callback.apply(null, arguments);
        }
    };
}

function isVisible(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function percentVisible(elem, percent) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    var elemPercent = elemTop + percent * $(elem).height() / 100;

    return ((elemPercent <= docViewBottom) && (elemTop >= docViewTop));
}

function animateElement(elem, willOpen, cb) {
    elem.removeClass('paused');
    var hasAnimEnded = false;
    $(elem).on('animationiteration', function() {
        if (hasAnimEnded)
            return;
        hasAnimEnded = true;

        if (willOpen)
            elem.removeClass('open').addClass('close');
        else
            elem.removeClass('close').addClass('open');
        elem.addClass('paused');

        if (cb)
            return cb();
    });
}

function isSafari() {
    var ua = navigator.userAgent.toLowerCase(); 
    if (ua.indexOf('safari') != -1) { 
      if (ua.indexOf('chrome') > -1) {
      } else {
        return true;
      }
    }
    return false;
}

var docViewBottomTrigger;
function updateColumnPositioning(docViewTop, docViewBottom) {

    var prodDrawer = $('.js-product-drawer').first();

    if ($(window).width() < desktopScreenWidth) {
        prodDrawer.css('position', '');
        prodDrawer.css('marginTop', '');
        prodDrawer.css('top', '');
        return;
    }else{
        var prodDrawerTop = prodDrawer.offset().top;
        var prodDrawerHeight = prodDrawer.height();
        var prodDrawerBottomMargin = (18 + 36 + 90); // 18 + 36 are padding and some white space at the bottom.
        var prodDrawerBottom = prodDrawerTop + prodDrawerHeight + prodDrawerBottomMargin;

        var offset = prodDrawerBottom - docViewBottom;
        if (offset < 0 && !docViewBottomTrigger) {
            prodDrawer.css('position', 'fixed');
            //prodDrawer.css('top', prodDrawerTop - $(window).scrollTop());

            var docViewHeight = docViewBottom - docViewTop;
            var top = docViewHeight - (prodDrawerHeight + prodDrawerBottomMargin);
            prodDrawer.css('top', top)
            docViewBottomTrigger = $('.page-container').offset().top + prodDrawerHeight + prodDrawerBottomMargin;
        } else if (docViewBottomTrigger && docViewBottom < docViewBottomTrigger) {
            prodDrawer.css('position', 'absolute');
            prodDrawer.css('top', 0);
            docViewBottomTrigger = null;
        }
        var reassuranceTop = $('#reassurance-points').offset().top;

        if (docViewBottom > reassuranceTop) {
            var diff = docViewBottom - reassuranceTop;
            prodDrawer.css('marginTop', -diff);
        } else if (prodDrawer.css('marginTop') != 0) {
            prodDrawer.css('marginTop', 0);
        }
    }

    var prodDrawerTop = prodDrawer.offset().top;
    var prodDrawerHeight = prodDrawer.height();
    var prodDrawerBottomMargin = (18 + 36 + 90); // 18 + 36 are padding and some white space at the bottom.
    var prodDrawerBottom = prodDrawerTop + prodDrawerHeight + prodDrawerBottomMargin;

    var offset = prodDrawerBottom - docViewBottom;
    if (offset < 0 && !docViewBottomTrigger) {
        prodDrawer.css('position', 'fixed');
        //prodDrawer.css('top', prodDrawerTop - $(window).scrollTop());

        var docViewHeight = docViewBottom - docViewTop;
        var top = docViewHeight - (prodDrawerHeight + prodDrawerBottomMargin);
        prodDrawer.css('top', top)
        docViewBottomTrigger = $('.page-container').offset().top + prodDrawerHeight + prodDrawerBottomMargin;
    } else if (docViewBottomTrigger && docViewBottom < docViewBottomTrigger) {
        prodDrawer.css('position', 'absolute');
        prodDrawer.css('top', 0);
        docViewBottomTrigger = null;
    }
    var reassuranceTop = $('#discoverCarousel').length > 0 ? $('#discoverCarousel').offset().top : $('#reassurance-points').offset().top;

    if (docViewBottom > reassuranceTop) {
        var diff = docViewBottom - reassuranceTop;
        prodDrawer.css('marginTop', -diff);
    } else if (prodDrawer.css('marginTop') != 0) {
        prodDrawer.css('marginTop', 0);
    }

}

/**
 * progressive anim with scroll
 */
function updateIfVisible(elem, animation, docViewBottom, topOffset, heightOffsetPercent) {
    if (!elem || !elem.length) // security
        return;
    
    var elemTop = elem.offset().top;
    var elemHeight = elem.height();
    var elemBottom = elemTop + elemHeight;
    var triggerHeight = elemTop + elemHeight * heightOffsetPercent;
    var fadeCourse = elemHeight * (1 - heightOffsetPercent);
    if (docViewBottom > triggerHeight + topOffset) {
        switch (animation) {
            case 'left':
                var left = -100 * (1 - (docViewBottom - triggerHeight - topOffset) / fadeCourse);
                left = Math.min(left, 0);
                elem.css('left', left); 
                break;
            case 'right':
                var left = 100 * (1 - (docViewBottom - triggerHeight - topOffset) / fadeCourse);
                left = Math.max(left, 0);
                elem.css('left', left); 
                break;
            case 'scale':
                var scale = 1 + 0.2 * (docViewBottom - triggerHeight - topOffset) / fadeCourse;
                elem.css('transform', 'scale(' + scale + ')'); 
                break;
            case 'opacity':
                elem.css('opacity', (docViewBottom - triggerHeight - topOffset) / fadeCourse);
                break;
        }
    }
}

function scrollToBox(boxName) {
    var elem = $('.js-product-desc__box-open[id=' + boxName + '__box-open]').first();

    var offset;
    if (h = $('.product-header__title-block').first().outerHeight()) {
        offset = 21 + h;
    } else {
        offset = 10;
    }
    var sizingTop = elem.offset().top - offset; // 2 for the line
    $('html, body').animate({scrollTop: sizingTop }, 1000, function() {
        if (!elem.find('.product-desc__box-plus').first().hasClass('close')) // only open if needed
            elem.trigger('click');
    });
}

function updateContentWidthAndDrawerPosition() {

    var imgHeight = $('.product-desc__pic').first().height();
    var windowHeight = $(window).height();
    //$('.page-container--new-product-page').css('maxWidth', Math.max(imgHeight, windowHeight) + (368 + 24));

    /*
    // move drawer
    var diff = $(window).width() - $('.page-container--new-product-page').width();
    if (diff > 0)
        $('.product-drawer, .js-product-drawer').css('right', diff / 2);
    */
}

var carousselImgWidthAr = new Array();
function updateCarousselsImgWidth() {
    $('.js-dotted-caroussel').each(function(i, elem) {
        var carousselId = $(elem).attr('id');
        var imgWidth = $(elem).children().first().width();
        carousselImgWidthAr[carousselId] = imgWidth;
    })
}

function initProductHighlightEvents() {
    $('.js-product-highlight').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        let highlight =  $(this).data('highlight'),
            desc,
            unit,
            displayWeight;

        if ($(this).data('type') == 'weight') {
            unit = $(this).data('type-unit');
            displayWeight = highlight;
        }

        if (unit == 'g') {
            displayWeight = highlight.replace('g', ' ' + theme.strings.product.grams);
        } else {
            displayWeight = highlight.replace(unit, ' ' + unit);
        }

        let size = $(this).data('size');

        if (size === "One Size") {
            desc = theme.strings.product.weightDescriptionSingleSize
                .replace('{{weight}}', displayWeight);
        } else if (size) {
            desc = theme.strings.product.weightDescription
                .replace('{{weight}}', displayWeight)
                .replace('{{size}}', String(size).replace('Size ', ''));
        } else {
            desc = productHighlightDescs[highlight];
        }


        $('#highlight-box__highlight').html(highlight);
        $('#highlight-box__desc').html(desc);
        // other highlights
        var isFirst = true;
        $('#highlight-box__other').html('');
        $('.js-product-highlight').each(function(e) {
            var otherHighlight = $(this).data('highlight');
            var isHighlight = (otherHighlight == highlight);
            $('#highlight-box__other').append('<a data-highlight="' + otherHighlight + '" class="js-product-highlight ' + (isFirst ? '' : 'ml-3') + ' cursor-pointer inline-block mx-0 font-simon text-btn2 h-[34px] px-4 py-2.5 rounded-[50px] border border-black text-center mb-2 md:text-btn2-d hover:bg-black hover:text-white ' + (isHighlight ? 'bg-black text-white' : '') + '">' + otherHighlight + '</a>');
            if (isFirst)
                isFirst = false;
        })
        $('#highlight-box-bkg').removeClass('hidden').addClass('flex');
        $('.js-product-highlight').off();
        $('#hightlight-box__close').off();
        $('#highlight-box-bkg').off();
        initProductHighlightEvents();
    })
    $('#hightlight-box__close, #highlight-box-bkg').click(function(e) {
        e.preventDefault();
        $('#highlight-box-bkg').removeClass('flex').addClass('hidden');
    })
}

document.querySelectorAll('.btn--select-size').forEach(element =>{
  element.addEventListener('click', function(e) {
    e.preventDefault();
    if(!element.classList.contains('btn--select-size-sticky')){
      element.textContent = theme.strings.selectSize;
    }
  });
});

window.addEventListener('load', function() {
  if (document.querySelector('.gtm--add-to-cart').getAttribute('data-available') == 'false') {
    const addToBag = document.querySelectorAll('.gtm--add-to-cart');
    const selectSize = document.querySelectorAll('.btn--select-size') ? document.querySelectorAll('.btn--select-size') : '';
    const klaviyoTriggers = document.querySelectorAll('.klaviyo-bis-trigger');
    klaviyoTriggers.forEach(trigger => {
      trigger.classList.remove('!hidden')
      addToBag.forEach(button => {
        button.classList.add('hidden');
      });
      selectSize.forEach(button => {
        button.classList.add('hidden');
      });
    });
  }
});

$(function() {

    // init
    /* stopping silhouette animation
    var silhouettesWidth = $('.product-desc__silhouettes').width();
    var silhouettesHolderWidth = $('.product-desc__silhouettes-holder').width();
    $('.product-desc__silhouettes-holder').scrollLeft((silhouettesWidth - silhouettesHolderWidth) / 2);
    */
    let isMobile;

    function checkViewportWidth() {

        if ($(window).width() < 768) {
            isMobile = true;

        } else {
            isMobile = false;
        }
    }

    // Initial check
    checkViewportWidth();

    var productHeaderTop = 68;
    var crossPromoOffsetInc = 200 / $('.product-desc__cross-promo-pic').length;
    var windowHeight = $(window).height();
    var productDrawerOffset = parseInt($('.js-product-drawer--20220516').data("offset"));

    let sizeSelected = false;
    let stickyActive = false;
    let outOfStock = false;

    $('.btn-side-silhouette') ? $('.btn-side-silhouette').on('click', () => openSideDrawer('side-silhouette')) : '';


    // Add Intersection Observer to .product-drawer__add-to-cart-holder
    const stickyAddCart = $('.product-drawer--sticky');
    const productAddCart = document.querySelector('.product-drawer__add-to-cart-holder');
    const stickyTitle = $('.ms-product--title');
    const stickyBtnSelectSize = $('.product-drawer--sticky .btn--select-size') ? $('.product-drawer--sticky .btn--select-size') : '';
    const stickySizeSelector = $('.sticky-size-selector');
    const btnNotify = $('.klaviyo-bis-trigger:not(.btn--sticky-notify)');
    const stickyBtnNotify = $('.btn--sticky-notify');
    const stickyBtnAddToCart = $('.product-drawer--sticky .gtm--add-to-cart');
    const btnAddToCart = $('.gtm--add-to-cart');
    const sizeClose = $('.product-drawer--close');
    const ressurancePoints = document.getElementById('reassurance-points');
    // const ressurancePoints = document.getElementById('ressurancePoints');
    const pdpSentinel = document.getElementById('pdpSentinel');
    // const productDesc = document.getElementById('productDesc');

    function notifyBtnDisplay(btn, state){
      if(state == 'show'){
        btn.removeClass('!hidden');
        btn.css('display', '');
      }else{
        btn.addClass('!hidden');
      }
    }

    function openStickyAdd(){
      stickyAddCart.addClass('sticky--active');
      stickySizeSelector.addClass('hidden');
      stickyTitle.addClass('flex');
      stickyTitle.removeClass('hidden');
      stickyBtnSelectSize.removeAttr('disabled')
      if (stickyBtnAddToCart.attr('data-available') == 'true'){
        notifyBtnDisplay(stickyBtnNotify);
        if(stickyBtnSelectSize.hasClass('hidden')){
          stickyBtnSelectSize.removeClass('hidden');
          stickyBtnAddToCart.addClass('hidden');
        }
      }
      stickyActive = true;
    }

    function closeStickyAdd(){
      stickyAddCart.removeClass('sticky--active');
      sizeClose.addClass('hidden');
      $('body').removeClass('freeze')
      stickyBtnSelectSize ? stickyBtnSelectSize.attr('disabled', 'disabled') : '';
      stickyActive = false;
    }

    function openSizes(){
      stickyTitle.removeClass('flex');
      stickySizeSelector.removeClass('hidden');
      sizeClose.removeClass('hidden');
      stickyTitle.addClass('hidden');
      $('body').addClass('freeze')
      if (sizeSelected && !outOfStock) {
        stickyBtnSelectSize.addClass('hidden');
        stickyBtnAddToCart.removeClass('hidden');
      } else if(sizeSelected && outOfStock){
        stickyBtnSelectSize.addClass('hidden');
        stickyBtnAddToCart.addClass('hidden');
        notifyBtnDisplay(stickyBtnNotify, 'show')
      }

    }

    function closeSizes(){
      stickyBtnAddToCart.hasClass('btn--add-one-size') ? '' : stickyBtnAddToCart.addClass('hidden');
      stickyTitle.addClass('flex');
      stickyTitle.removeClass('hidden');
      stickySizeSelector.addClass('hidden');
      notifyBtnDisplay(stickyBtnNotify)
      sizeClose.addClass('hidden');
      stickyBtnSelectSize.removeClass('hidden');
      stickyBtnSelectSize.removeAttr('disabled');
      $('body').removeClass('freeze')
    }


    if (stickyTitle) {
      const observerAdd = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!stickyActive && entry.boundingClientRect.y < 200 && !entry.isIntersecting) {
                openStickyAdd();
            }
            else if (stickyActive){
                closeStickyAdd();
            }
          });
        }, {
          root: null, // Use the viewport as the root 
          threshold: 0, // Trigger when the element reaches the top
          rootMargin: '0px 0px 0px 0px' // Adjust this value to fine-tune the trigger point
        });

        observerAdd.observe(productAddCart);

        const observerRmv = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
              if (stickyActive && entry.isIntersecting) {
                  closeStickyAdd();
              }
          });
        }, {
          root: null, // Use the viewport as the root
          threshold: 0, // Trigger when the element reaches the top
          rootMargin: '0px 0px 0px 0px' // Adjust this value to fine-tune the trigger point
        });

        observerRmv.observe(pdpSentinel);

        const stopObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (stickyActive && entry.isIntersecting) {
              closeStickyAdd();
            }else if(!stickyActive && !entry.isIntersecting && entry.boundingClientRect.y < 1500  && entry.boundingClientRect.y > 0){
              openStickyAdd();
            }
          });
        }, {
          root: null, // Use the viewport as the root
          threshold: 0, // Trigger when the element reaches the top
        });

        stopObserver.observe(ressurancePoints);

        // Manually check scroll position after page load
        window.addEventListener('load', function() {
            //set timeout of 500ms to allow page to load
            setTimeout(() => {
                checkScrollPosition();
            }, 500);
        });

        function checkScrollPosition() {
            if (!stickyActive && productAddCart.getBoundingClientRect().y < 200) {
            openStickyAdd();
            }
        }

    }

    stickyBtnSelectSize ? stickyBtnSelectSize.on('click', (e) => {
        $(this).attr('disabled', 'disabled')
        openSizes()
    }) : '';

    sizeClose.on('click', (e) => {
        closeSizes();
    });


    if (stickyBtnSelectSize) {
        stickyBtnAddToCart.on('click', function (e) {
            setTimeout(() => {
              closeSizes();
            }, 3500);
        })
    }

    updateContentWidthAndDrawerPosition();
    updateCarousselsImgWidth();

    // when resize
    $(window).resize(throttle(300,function() {
      updateContentWidthAndDrawerPosition();
      windowHeight = $(window).height();
      updateCarousselsImgWidth();
      updateColumnPositioning();
      checkViewportWidth();
      updateClicks();
  }));

    // HEADER show/hide
    $(document).on('scroll', throttle(0, function() {
        var scrollTop = $(document).scrollTop();

        var ref = productHeaderTop;
        if ($('#shopify-section-norda-product-header').length)
            ref += $('#shopify-section-norda-product-header').height();
        if ($('#shopify-section-crocs-product-header').length)
            ref += $('#shopify-section-crocs-product-header').height();
        if ($('#shopify-section-oakley-product-header').length)
            ref += $('#shopify-section-oakley-product-header').height();            
        if ($('#shipping-banner:visible').length)
            ref += $('#shipping-banner:visible').outerHeight();

        if (scrollTop >= ref) {
            if (!$('.product-header').hasClass('product-header--sticky'))
                $('.product-header').addClass('product-header--sticky');
        } else {
            if ($('.product-header').hasClass('product-header--sticky'))
                $('.product-header').removeClass('product-header--sticky');
        }

    }))

    $(document).on('scroll', throttle(0, function() { // THROTTLE TO BE FIXED

        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + windowHeight; 

        /* REFLECTIVE */
        //var e;
        //var e = $('.product-desc__reflective--black').first();
        //updateIfVisible(e, 'opacity', docViewBottom, 0, 0.5);

        $('.product-desc__reflective--black').each(function(i, e) {
            updateIfVisible($(e), 'opacity', docViewBottom, 0, 0.5);
        })
        
        $('.product-desc__pic-desc').each(function(i, e) {
            updateIfVisible($(e), 'opacity', docViewBottom, 200, 0);
        })

        $('.product-desc__pic-detail img').each(function(i, e) {
            updateIfVisible($(e), 'scale', docViewBottom, 100, 0);
        })

        var offset = 0;
        $('.product-desc__similar-pic').each(function(i, e) {
           updateIfVisible($(e), 'opacity', docViewBottom, 100 + offset, 0);
           if (i < 2) // not more than 4 otherwise too low
            offset += 100;
        })

        offset = 0;
        $('.product-desc__cross-promo-pic').each(function(i, e) {
           updateIfVisible($(e), 'opacity', docViewBottom, offset, 0);
            offset += crossPromoOffsetInc;
        })

        /* stopping silhouette animation
        var e = $('.product-desc__silhouette:first');
        updateIfVisible($(e), 'left', docViewBottom, 0, 0);
        e = $('.product-desc__silhouette').eq(2);
        updateIfVisible($(e), 'right', docViewBottom, 0, 0);
        */


        /*
        var limit = 729 + productDrawerOffset;
        var prodDrawer = $('.js-product-drawer--20220516');

        if (prodDrawer.length) {
            var reassuranceTop = $('#reassurance-points').offset().top - docViewTop;
            console.log(reassuranceTop);
            if (reassuranceTop < limit) {
                prodDrawer.css('top', (135 + reassuranceTop - limit) + 'px'); 
            } else {
                prodDrawer.css('top', '135px');
            }
        }
        */

        updateColumnPositioning(docViewTop, docViewBottom);

    }))

    var currentCarousselImgAr = new Array();
    $('.js-dotted-caroussel').each(function(i, elem) {
        var carousselId = $(elem).attr('id');
        $(elem).on('scroll', throttle(300, function() {
            var imgWidth = carousselImgWidthAr[carousselId];
            var scrollPos = $(elem).scrollLeft();
            var selectedImg = Math.floor(1.5 + scrollPos / imgWidth);
            if (selectedImg != currentCarousselImgAr[carousselId]) {
                var dots = $('.caroussel-dots[caroussel=' + carousselId + ']').children('.caroussel-dot');
                dots.removeClass('caroussel-dot--selected');
                dots.eq(selectedImg - 1).addClass('caroussel-dot--selected');
                currentCarousselImgAr[carousselId] = selectedImg;
            }    
        }))
    })

    $('.js-product-page__size-btn').click(function(e) {
        e.preventDefault();

        sizeSelected = true;

        $('.btn--select-size').addClass('hidden');
        $('.gtm--add-to-cart').prop('disabled', false);
        $('.gtm--add-to-cart').removeClass('hidden');

        // update value
        var val = $(this).data('val');
        $('.js-product-page__size-select').val(val);
        $('.js-product-page__size-select').trigger('change');

        // update button color
        $('.product-header__size-btn').removeClass('product-header__size-btn--selected');
        $(this).parent().parent().addClass('product-header__size-btn--selected');


        // update button color new
        var selectedElem = this;
        var bgColor = $(this).attr('data-color-bg');
        var textColor = $(this).attr('data-color-text');
        $('.js-product-page__size-btn').each(function() {

            var qty = $(this).attr('qty');
            if ($(this).is(selectedElem)) {
                $(this).children(":first").removeClass('bg-white text-black text-gray').css({'background-color':bgColor,'color':textColor});
                $(this).removeClass("before:bg-black bg-white before:bg-black text-black text-gray border-gray").css({'background-color':bgColor,'border':'1px solid '+bgColor,'color':textColor});
                if (qty == "0") {
                    $(this).addClass("before:absolute before:left-1/2 before:content-[''] before:w-px before:h-[141%] before:bg-current before:rotate-45")
                } else {
                    $(this).removeClass("before:bg-current before:absolute before:left-1/2 before:content-[''] before:w-px before:h-[141%] before:rotate-45")
                }

            } else {
                if (qty == "0") {
                    $(this).children(":first").removeClass('text-black bg-black text-white').css({'background-color':'','color':''}).addClass('bg-white text-gray');
                    $(this).removeClass("before:bg-black before:bg-current bg-black text-white before:bg-black text-black border-black").css({'border':'','background-color':'', 'color':''}).addClass("before:absolute before:left-1/2 before:content-[''] before:w-px before:h-[141%] before:bg-current before:rotate-45 bg-white text-gray border-gray");
                } else {
                    $(this).children(":first").removeClass('bg-black text-white text-gray').css({'background-color':'','color':'#000000'}).addClass('bg-white');
                    $(this).removeClass("before:bg-black before:bg-current bg-black text-white before:absolute before:left-1/2 before:content-[''] before:w-px before:h-[141%] before:bg-black before:rotate-45 text-gray border-gray").css({'border':'','background-color':''}).addClass("text-black border-black bg-white");
                }
            }

        })

        let klaviyoBIS = document.querySelectorAll('.klaviyo-bis-trigger') ? document.querySelectorAll('.klaviyo-bis-trigger') : null;

        // update one left or not.
        var qty = $(this).attr('qty');
        // var varId = $(this).attr('data-var');
        var varId = $(this).attr('data-variant-id');
        if (qty == "1") {
            $('.gtm--add-to-cart span').text(theme.strings.addToCart +' - '+ theme.strings.oneLeft);
            btnAddToCart.removeClass('hidden');
            notifyBtnDisplay(btnNotify)
            notifyBtnDisplay(stickyBtnNotify)
            outOfStock = false;
        } else if (qty == "0") {
            $('.gtm--add-to-cart span').text(theme.strings.soldOut);
            btnAddToCart.addClass('hidden');
            btnNotify.attr('data-variant-id', varId);
            stickyBtnNotify.attr('data-variant-id', varId);
			notifyBtnDisplay(btnNotify, 'show')
			if(stickyActive){
				notifyBtnDisplay(stickyBtnNotify, 'show')
			}
            outOfStock = true;
        } else {
            $('.gtm--add-to-cart span').text(theme.strings.addToCart);
            $('.gtm--add-to-cart').attr('disabled', false);
            // addToCart.style.display = 'block';
			notifyBtnDisplay(btnNotify)
			notifyBtnDisplay(stickyBtnNotify)
            stickyBtnAddToCart.removeClass('hidden');
            btnAddToCart.removeClass('hidden');
            outOfStock = false;
        }

        function updateKlaviyoSelect(iframe){
            let klaviyoSelect = iframe.contentWindow.document.querySelector("select");

            if (klaviyoSelect) {
                klaviyoSelect.value = varId;
                
                // Ensure iOS detects the change
                klaviyoSelect.dispatchEvent(new Event("input", { bubbles: true }));
                klaviyoSelect.dispatchEvent(new Event("change", { bubbles: true }));
                klaviyoSelect.dispatchEvent(new Event("click", { bubbles: true }));

            }
        }

        if (klaviyoBIS.length > 0) {
            klaviyoBIS[0].addEventListener('click', function() {
                let klaviyoIframe = document.getElementById("klaviyo-bis-iframe");
                klaviyoIframe.onload = function () {
                    updateKlaviyoSelect(klaviyoIframe);
                };
            });
        }

    })

    $('.js-product-page__size-guide').click(function(e) {
        e.preventDefault();
        openSideDrawer('side-product-guide')
    })


    $('.js-product-page__reviews').click(function(e) {
        e.preventDefault();
        scrollToBox('reviews');
    })

    let activeScrollHandler = null; // Store the active scroll handler

    function handleBoxScrollEvent(e, initialScrollPosition) {
  
      // Remove the previous scroll handler if it exists
      if (activeScrollHandler) {
        $(document).off('scroll', activeScrollHandler);
      }
  
      const scrollHandler = function() {
  
        if ($(document).scrollTop() > initialScrollPosition + 300 || $(document).scrollTop() < initialScrollPosition - 300) {
          handleDropdownClick(e);
          $(document).off('scroll', scrollHandler);
          activeScrollHandler = null;
        }
      };
  
      $(document).on('scroll', scrollHandler);
      activeScrollHandler = scrollHandler; // Store handler reference
    }


    function handleDropdownClick(e){
      e.preventDefault();
      let box = $(e.currentTarget).parent()[0];
  
      if ($(box).data('is-animating'))
          return;
  
      if (!isMobile && $(e.currentTarget).hasClass('btn-side-desc-boxes')) {
          return;
      }
  
      let plusSign = $(e.currentTarget).parent('.product-desc__box').find('.product-desc__box-plus');
  
      let willOpen;
      let targetHeight;
  
      $(box).data('is-animating', true);
  
      if ($(box).data('original-height')) {
        willOpen = false;
        targetHeight = $(box).data('original-height');
        $(box).removeData('original-height').removeClass('active');
      } else {
        willOpen = true;
        targetHeight = Math.round(box.scrollHeight);
        $(box).data('original-height', $(box).outerHeight()).addClass('active');
      }
  
      animateElement(plusSign, willOpen)
  
      $(box).animate({height: targetHeight}, 400, 'swing', function() {
          $(box).removeData('is-animating');
      });
  
      // Close any other open sections
      closeDescBoxes(box,e.currentTarget, willOpen);
  
      if (willOpen && $(box).closest('.product-desc__boxes').parent().attr('id') === 'productMoreInfo') {
        let initialScrollPosition = $(document).scrollTop();
        handleBoxScrollEvent(e, initialScrollPosition);
      }
    }

    function closeDescBoxes(b, t, w){
      let defaultHeight = w ? $(t).parent().outerHeight() : $(b).data('original-height');
      $(t).closest('.product-desc__boxes').children().each(function() {
        let otherBox = $(this);
        let otherPlusSign = $(this).find('.product-desc__box-plus');
        if (otherBox[0] !== b && $(otherBox).height() > defaultHeight) {
          $(otherBox).animate({height: defaultHeight}, 400, 'swing', function() {
            $(otherBox).removeData('is-animating');
            $(otherBox).removeData('original-height');
            otherPlusSign.removeClass('close').addClass('open paused');
          });
        }
      });
  
      // Remove scroll handler if switching to another box
      if (activeScrollHandler) {
        $(document).off('scroll', activeScrollHandler);
        activeScrollHandler = null;
      }
    }
  
    function updateClicks(){
      $('.js-product-desc__box-open').click(function(e) {
        handleDropdownClick(e)
      })
    }

    updateClicks()


    $('.js-product-header__scroll-to-drawer').click(function(e) {
        e.preventDefault();

        var elem = $('.product-drawer__size').first();
        var offset;
        if (h = $('.product-header__title-block').first().outerHeight()) {
            offset = 14 + h;
        } else {
            offset = 10;
        }
        var drawerTop = elem.offset().top - offset;
        $('html, body').animate({scrollTop: drawerTop }, 500);
    })

    $('.js-to-shipping-box').click(function(e) {
        e.preventDefault();
        scrollToBox('shipping___returns');
    })

    $('.product-desc__box[box-name="reviews"').click(function(e){
        $(this).css('height', 'auto');
    })

    // CAROUSSEL
    $('.js-caroussel-dot').click(function(e) {
        e.preventDefault();
        var carouselId = $(this).parent().attr('caroussel');
        var carousel = $('#' + carouselId);
        var picPos = parseInt($(this).attr('picpos'));
        var left = picPos * $('#' + carouselId).children().first().width();
        carousel.removeClass('snap-x');
        carousel.stop().animate(
            { scrollLeft: left },
            500,
            () => carousel.addClass('snap-x')
        );
    })
    $('.js-caroussel-arrow').click(function(e) {
        e.preventDefault();

        var carouselId = $(this).attr('caroussel');
        var carousel = $('#' + carouselId);
        var dir = $(this).attr('direction');
        var imgWidth = carousel.children().first().width();
        var nbImages = carousel.children().length;
        var left = carousel.scrollLeft();

        if (dir == 'left')
            left -= imgWidth;
        else
            left += imgWidth;

        maxLeft = imgWidth * (nbImages - 1);

        if (left < -10) // -10 is a margin. 0 should be ok but is not in all situations. Anyway, no pic we use is narrower than 10px
            left = maxLeft;
        else if (left > maxLeft)
            left = 0;

        carousel.removeClass('snap-x');
        carousel.stop().animate(
            { scrollLeft: left },
            500,
            () => carousel.addClass('snap-x')
        );

    })

    // lense selector
    $('.js-lens-selector').click(function(e) {

        var lightTransmission, lightConditions, leftPercent;

        var color = $(this).data('color');
        switch (color) {
            case 'black':
                lightTransmission = 11;
                lightConditions = 'BRIGHT LIGHT';
                leftPercent = 9;
                break;
            case 'ruby':
                lightTransmission = 17;
                lightConditions = 'BRIGHT LIGHT';
                leftPercent = 13;
                break;
            case 'brown':
                lightTransmission = 14;
                lightConditions = 'BRIGHT LIGHT';
                leftPercent = 11;
                break;
            case 'pink':
                lightTransmission = 75;
                lightConditions = 'LOW LIGHT';
                leftPercent = 72;
                break;
        }

        $('#light-transmission-fill').css('width', lightTransmission + '%');
        $('#light-transmission-caption').removeClass('left-[11%] left-[14%] left-[22%] left-[75%] lg:left-[9%] lg:left-[11%] lg:left-[14%] lg:left-[61%]');
        $('#light-transmission-caption').addClass('left-[' + lightTransmission + '%]').addClass('lg:left-[' + leftPercent + '%]');
        $('#light-transmission-caption').text(lightTransmission + '%');

        // light conditions
        $('.js-light-condition').each(function() {
            var caption = $(this).find('p').first().text();
            var blackBlock = $(this).find('div').first();
            if (caption == lightConditions) {
                blackBlock.removeClass('bg-white-off').addClass('bg-black');
            } else {
                blackBlock.removeClass('bg-black').addClass('bg-white-off');
            }
        })

        // btns
        $('.js-lens-selector').each(function(e) {
            $(this).removeClass('underline');
            $(this).css('fontWeight', 400);
        })
        $(this).addClass('underline');
        $(this).css('fontWeight', 500);


    })

    initProductHighlightEvents();

    /* This block to prevent issues blocking display of the full review input box when only one review */
    /*
    $('.stamped-summary-actions-newreview, .stamped-summary-actions-newquestion').click(function() {
        setTimeout(() => {
            var descBox = $('.product-desc__box[box-name=reviews]')[0];
            $(descBox).animate({height: Math.round(descBox.scrollHeight)}, 400, 'swing', function() {});
        }, 500);
    })
    */

    function initClickReviewNavigation() {
        $('.stamped-pagination a, .stamped-summary-actions-newreview, .stamped-summary-actions-newquestion').click(function() {
            setTimeout(() => {
                var descBox = $('.product-desc__box[box-name=reviews]')[0];
                $(descBox).animate({height: 'auto'}, 400, 'swing', function() {
                    initClickReviewNavigation(); // required since the clickable components are removed and added again
                });
            }, 1000);
        })
    }

    /* This block to prevent issues when a page contains answers and we need to adapt the page height */
    setTimeout(() => {
        initClickReviewNavigation();

        if(window.location.hash) {
            var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
            console.log(hash);
            if (hash == 'stamped-main-widget') {
                console.log('HERE');
                scrollToBox('reviews');
                $('.stamped-summary-actions-newreview').trigger('click');
            }
        }
    }, 1000)

    // INIT
    $(document).trigger('scroll');

    const url = new URL(window.location.href)
    const searchParams = url.searchParams
    const queryID = searchParams.get('queryID')
    const objectID = $("#ProductSelect-product-template-norda :selected").val();

    window.aa('init', {
        appId: 'A2HDJIN1DW',
        apiKey: '47452381365eabfc80fc5b9fcf112597',
    });

    const addToCartBtn = document.getElementById('AddToCart-product-template-norda');

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function (e) {
          window.aa('addedToCartObjectIDsAfterSearch', {
              eventName: 'Product Added to Cart',
              index: 'shopify_products',
              queryID: queryID,
              objectIDs: [objectID]
          });
      })
    }

    var initialPopupTop;

    function openLoginModal(){

        $('body').addClass('freeze');
        $('.login-popup-overlay').show().animate({opacity: 0.7}, 250, 'swing', function() {})
        $('.login-popup-div').addClass('flex active');
        $('.login-popup__content').delay(100).show().animate({opacity: 1.0}, 150, 'swing', function() {})
    }

    closePopup = function() {

        $('.login-popup__content').animate({opacity: 0}, 150, 'swing', function() {
            $('.login-popup-div').removeClass('flex active');
        })
        $('.login-popup-overlay').delay(100).animate({opacity: 0.0}, 250, 'swing', function() {
            $('.login-popup-overlay').hide();
            $('body').removeClass('freeze');
        })
    }

    $('.js-popup-close').click(function(e) {
        e.preventDefault();
        closePopup();
    })

    $('.btn--login') ? $('.btn--login').click(function() {
        openLoginModal();
    }) : '';

});
  